<template>
  <div id="app" class>
    <!-- For Buefy icons. -->
    <link
      rel="stylesheet"
      href="https://use.fontawesome.com/releases/v5.7.0/css/all.css"
    />

    <div id="page">
      <router-view />
    </div>
    <b-message
      type="is-info"
      size="is-medium"
      :active="this.$store.getters.statusBox === 'wait_add_location'"
      aria-close-label="Close message"
      title="Saving"
      :closable="false"
      style="position: fixed;
    bottom: 8%;
    left: 50%;
    z-index: 100;"
    >
      <b-icon
        icon="sync-alt"
        pack="fas"
        size="is-small"
        custom-class="fa-spin"
      ></b-icon>
      Adding location &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
    </b-message>

    <b-message
      type="is-success"
      auto-close
      duration="2000"
      size="is-medium"
      title="Success"
      :active="this.$store.getters.statusBox === 'added_location'"
      aria-close-label="Close message"
      :closable="false"
      style="position: fixed;
    bottom: 8%;
    left: 50%;
    z-index: 100;"
    >
      <b-icon icon="check" pack="fas" size="is-small"></b-icon>
      Added a new location
    </b-message>

    <b-message
      type="is-danger"
      auto-close
      duration="2500"
      size="is-medium"
      title="Error"
      :active="this.$store.getters.statusBox === 'generic_error'"
      aria-close-label="Close message"
      :closable="false"
      style="position: fixed;
    bottom: 8%;
    left: 50%;
    z-index: 100;"
    >
      <b-icon icon="exclamation-circle" pack="fas" size="is-small"></b-icon>
      An error has occurred.
    </b-message>

    <!-- <b-message
      type="is-info"
      auto-close="true"
      duration="2000"
      :active="true"
      aria-close-label="Close message"
      :closable="false"
      style="position: absolute;
    bottom: 8%;
    left: 25%;"
    >
        <b-icon icon="sync-alt" pack="fas" size="is-small" custom-class="fa-spin"></b-icon>
      Adding location &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
    </b-message>
    <b-message
      type="is-success"
      auto-close="true"
      duration="2000"
      :active="true"
      aria-close-label="Close message"
      :closable="false"
      style="position: absolute;
    bottom: 8%;
    left: 25%;"
    >
        <b-icon icon="check" pack="fas" size="is-small"></b-icon>
         Added a new location
    </b-message> -->
  </div>
</template>

<script>
export default {
  name: "app",
  created: function() {
    document.documentElement.style.setProperty(
      "--app-height",
      `${window.innerHeight}px`
    );
    window.addEventListener("resize", () => {
      document.documentElement.style.setProperty(
        "--app-height",
        `${window.innerHeight}px`
      );
    });
  }
};
</script>

<style lang="scss">
$primary: #209cee;
// Import custom fonts.
@import url("https://fonts.googleapis.com/css?family=Inter:400,500,600,700");
$family-sans-serif: "Inter", Helvetica, Arial, sans-serif;
// Import Bulma's core.
@import "~bulma/sass/utilities/_all";
// Import Bulma and Buefy styles.
@import "~bulma";
@import "~buefy/src/scss/buefy";

:root {
  --app-height: 100%;
}

#app {
  font-family: "Inter", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100vh;
}

@media (max-width: 768px) {
  #app {
    height: var(--app-height);
  }
}

#page {
  height: 100%;
}

#nav {
  /* padding: 30px; */
  text-align: right;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

footer {
  background: #42a5f5;
  color: white;
}
</style>
